import React from 'react';

const Tokeninformation = () => {
  return <>
      <div className='container'>
          <h3 className='text-white mt-3'>TOKEN INFORMATION</h3>
          <div className='row'>
              <div className='col-md-12 tokentext' >
             <span style={{color:'white',opacity:'50%'}}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</span> 
              </div>
          </div>
          <div className='row'>
              <div className='col-md-12 infortext mt-5'>
             <span style={{color:'white',opacity:'50%'}}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</span> 
              </div>
          </div>

          <div className='row'>
              <div className='col-md-8 infortext mt-5'>
             <span style={{color:'white',opacity:'50%'}}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</span> 
              </div>
              <div className='col-md-4 infortext mt-5'>
              <img src="https://samurai.cyberfi.tech/_nuxt/img/1.dfffc95.png" class="img-fluid" alt="Responsive image"/>
              </div>
          </div>
          <div className='row'>
              <div className='col-md-8 infortext '>
              <div className='col-md-12 textindustry'>
             
              <span style={{color:'white',opacity:'50%'}}>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</span> 
              </div>
              <div className='col-md-12 mt-1'>
              <span style={{color:'white',opacity:'50%'}}>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</span> 
              </div>
              <div className='col-md-12 mt-1'>
              <span style={{color:'white',opacity:'50%'}}>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</span> 
              </div>
              </div>
          </div>

          <div className='row'>
          <div className='col-md-4 infortext mt-5'>
              <img src="https://samurai.cyberfi.tech/_nuxt/img/2.369f8ff.png" class="img-fluid" alt="Responsive image"/>
              </div>
              
              <div className='col-md-8 infortext mt-5'>
             <span style={{color:'white',opacity:'50%'}}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</span> 
              </div> 
          </div>

          
      </div>
  </>;
};

export default Tokeninformation;
